import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './privacy-botafogo-modal.styles';

const PrivacyBotafogoModal: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  return (
    <Styles.Body>
      <Styles.Text>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_TITLE'])}
      </Styles.Text>
      <Styles.TextInfo>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_MESSAGE'])}
      </Styles.TextInfo>
      <Styles.LinksContainer>
        <Styles.LinkContainer>
          <Styles.Link
            href="https://static.botafogo.com.br/upload/downloads/0dd68d42982342a7a23067e5f0663d52.mp4"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_VIDEO'])}
          </Styles.Link>
        </Styles.LinkContainer>
        <Styles.LinkContainer>
          <Styles.Link
            href="https://static.botafogo.com.br/upload/downloads/43cc4905f1994b99a07cc2d36a0b2fbf.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_SUMMARY'])}
          </Styles.Link>
        </Styles.LinkContainer>
        <Styles.LinkContainer>
          <Styles.Link
            href="https://static.botafogo.com.br/upload/downloads/4028484f6eb54ebe9216a01021efe7ee.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_COMPLETE'])}
          </Styles.Link>
        </Styles.LinkContainer>
      </Styles.LinksContainer>
      <Styles.TextInfo>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_MESSAGE_SECOND'])}
      </Styles.TextInfo>
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default PrivacyBotafogoModal;
